/**
 * Pure loyalty-expiry helpers — no state, no DI. Extracted from
 * DashboardComponent.getLoyaltyExpiryDays/Text/Class (unchanged logic),
 * now shared by LoyaltyService.
 */

/** Days remaining until expiry (negative = already expired). -1 = no expiry set. */
export function getLoyaltyExpiryDays(expiryDate: string | null | undefined): number {
  if (!expiryDate) {
    return -1; // No expiry
  }

  const expiry = new Date(expiryDate);
  const today = new Date();
  today.setHours(0, 0, 0, 0);
  expiry.setHours(0, 0, 0, 0);

  const diffTime = expiry.getTime() - today.getTime();
  return Math.ceil(diffTime / (1000 * 60 * 60 * 24));
}

export function getLoyaltyExpiryText(expiryDate: string | null | undefined): string {
  if (!expiryDate) {
    return 'No Expiry';
  }

  const daysRemaining = getLoyaltyExpiryDays(expiryDate);

  if (daysRemaining < 0) {
    return 'Expired';
  } else if (daysRemaining === 0) {
    return 'Expires Today';
  } else if (daysRemaining === 1) {
    return 'Expires Tomorrow';
  } else if (daysRemaining <= 7) {
    return `Expires in ${daysRemaining} days`;
  } else if (daysRemaining <= 30) {
    return `Expires in ${daysRemaining} days`;
  } else {
    const expiry = new Date(expiryDate);
    return `Expires on ${expiry.toLocaleDateString('en-GB')}`;
  }
}

export function getLoyaltyExpiryClass(expiryDate: string | null | undefined): string {
  const daysRemaining = getLoyaltyExpiryDays(expiryDate);

  if (daysRemaining < 0) {
    return 'text-danger';
  } else if (daysRemaining <= 7) {
    return 'text-danger';
  } else if (daysRemaining <= 30) {
    return 'text-warning';
  } else {
    return 'text-success';
  }
}
